import { render, staticRenderFns } from "./GalleryFullscreen.vue?vue&type=template&id=4221dba0"
import script from "./GalleryFullscreen.vue?vue&type=script&lang=js"
export * from "./GalleryFullscreen.vue?vue&type=script&lang=js"
import style0 from "./GalleryFullscreen.vue?vue&type=style&index=0&id=4221dba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports